export default "<div data-component=\"app-current-page-box\">\n  <a class=\"secondary\"><ng-content></ng-content></a>\n</div>\n"